// extracted by mini-css-extract-plugin
export default {"block":"login_block__EFsx0","text":"login_text__I07yL","title":"login_title__O4MZp","form":"login_form__2L96z","link":"login_link__2qae1"};